import { type FC } from "react";
import { useFlags } from "../../../server/optimizely";
import { ApplicationLayout } from "./application-layout";
import { Layout } from "./layout";

export const ContentLibraryLayout: FC = () => {
  const {
    flags: { folders },
    flagsLoaded,
  } = useFlags("folders");

  if (!flagsLoaded) {
    return <></>;
  }

  if (folders) {
    return <ApplicationLayout layout="content" />;
  }

  return <Layout />;
};
